

var routemap={



    neo:{
        node( o ){
            return {
                id:'elementId',
                a:'toid',
                b:'fromid'
            }
        },
        edge(){


        }
    }
    
}






export default {



    fields( originin ){


        
    }


}